/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';

const { model, boolean, string } = types;

export const AppPreloaderStore = model('AppPreloaderStore', {
  show: boolean,
  type: string,
  size: string,
})
  .views((self) => ({}))
  .volatile(() => ({}))
  .actions((self) => ({
    setPreloaderState: (show: boolean, type: string, size: string): void => {
      self.show = show;
      self.type = type;
      self.size = size;
    },
    disablePreloader(): void {
      self.show = false;
    },
  }));

export type IAppPreloaderStore = Instance<typeof AppPreloaderStore>;
